import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32bc1916")

_pushScopeId("data-v-32bc1916")
const _hoisted_1 = { class: "center title-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_simulation_contact_card = _resolveComponent("simulation-contact-card")
  const _component_simulation_works_card = _resolveComponent("simulation-works-card")
  const _component_simulation_resume = _resolveComponent("simulation-resume")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("dig-ui-title", _hoisted_1, _toDisplayString($setup.t('newSimulation')), 1),
    _createVNode(_component_simulation_contact_card, {
      class: "card",
      simulation: $setup.simulation,
      onUpdate: _cache[1] || (_cache[1] = ($event: any) => ($setup.update($event))),
      onReset: _cache[2] || (_cache[2] = ($event: any) => ($setup.resetContact()))
    }, null, 8, ["simulation"]),
    _createVNode(_component_simulation_works_card, {
      class: "card",
      simulation: $setup.simulation,
      onUpdate: _cache[3] || (_cache[3] = ($event: any) => ($setup.update($event))),
      onUpdateCee: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateCee($event))),
      onReset: _cache[5] || (_cache[5] = ($event: any) => ($setup.resetWorks()))
    }, null, 8, ["simulation"]),
    _createVNode(_component_simulation_resume, {
      simulation: $setup.simulation,
      onUpdate: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateField($event)))
    }, null, 8, ["simulation"])
  ], 64))
})